import {

    CARGAR_PAISES_UBICACION_SOLICITO,
    CARGAR_PAISES_UBICACION_EXITO,
    CARGAR_PAISES_UBICACION_ERROR,

    CARGAR_CONFIG_PAIS_UBICACION_SOLICITO,
    CARGAR_CONFIG_PAIS_UBICACION_EXITO,
    CARGAR_CONFIG_PAIS_UBICACION_ERROR,

    CARGAR_OPCIONES_UBICACION_SOLICITO,
    CARGAR_OPCIONES_UBICACION_EXITO,
    CARGAR_OPCIONES_UBICACION_ERROR,

    CARGAR_PROVINCIAS_UBICACION_SOLICITO,
    CARGAR_PROVINCIAS_UBICACION_EXITO,
    CARGAR_PROVINCIAS_UBICACION_ERROR,

    CARGAR_DEPARTAMENTOS_UBICACION_SOLICITO,
    CARGAR_DEPARTAMENTOS_UBICACION_EXITO,
    CARGAR_DEPARTAMENTOS_UBICACION_ERROR,

    CARGAR_LOCALIDADES_UBICACION_SOLICITO,
    CARGAR_LOCALIDADES_UBICACION_EXITO,
    CARGAR_LOCALIDADES_UBICACION_ERROR

} from '../types';

import clienteAxios from '../config/axios';


/*
====================================
HELPERS
====================================
*/


/*
Genera una clave única para guardar
cada consulta territorial en Redux.

Ejemplos:

CL|1|ROOT
CL|2|13
CL|3|131
MX|2|14
*/

export const crearClaveOpcionesUbicacion = (
    pais,
    nivel,
    parent = null
) => {

    return `${pais}|${nivel}|${parent || 'ROOT'}`;

};


/*
====================================
PAÍSES
====================================
*/

export function cargarPaisesUbicacionAction(
    informacion
) {

    return async (
        dispatch,
        getState
    ) => {

        const estadoUbicacion =
            getState()
                .ubicacion;


        const paises =
            estadoUbicacion
                .paises;


        const loading =
            estadoUbicacion
                .loadingPaises;


        /*
        Si ya fueron cargados o existe
        una consulta en curso, evitamos
        hacer otro GET.
        */

        if (
            paises.length > 0 ||
            loading
        ) {

            return;

        }


        dispatch(
            cargarPaisesSolicito()
        );


        try {

            const {
                config
            } = informacion;


            const respuesta =
                await clienteAxios.get(
                    '/ubicacion/paises',
                    config
                );


            const paisesRecibidos =
                respuesta
                    .data
                    .informacion ||
                [];


            const paisesOrdenados =
                [
                    ...paisesRecibidos
                ].sort(
                    (
                        a,
                        b
                    ) => {

                        /*
                        "Otro país" siempre queda último.
                        */

                        if (
                            a.codigo === 'OTRO'
                        ) {

                            return 1;

                        }


                        if (
                            b.codigo === 'OTRO'
                        ) {

                            return -1;

                        }


                        return a.nombre.localeCompare(
                            b.nombre,
                            'es',
                            {
                                sensitivity:
                                    'base'
                            }
                        );

                    }
                );


            dispatch(
                cargarPaisesExito(
                    paisesOrdenados
                )
            );


        } catch (
            error
        ) {

            const mensaje =
                error.response?.data ||
                {
                    msg:
                        'No se pudieron cargar los países'
                };


            dispatch(
                cargarPaisesError(
                    mensaje
                )
            );

        }

    };

}


const cargarPaisesSolicito =
    () => ({

        type:
            CARGAR_PAISES_UBICACION_SOLICITO

    });


const cargarPaisesExito =
    (informacion) => ({

        type:
            CARGAR_PAISES_UBICACION_EXITO,

        payload:
            informacion

    });


const cargarPaisesError =
    (error) => ({

        type:
            CARGAR_PAISES_UBICACION_ERROR,

        payload:
            error

    });


/*
====================================
CONFIGURACIÓN PAÍS
====================================

Ejemplo:

POST /ubicacion/config

Body:

{
    pais: 'CL'
}

La configuración indica al frontend
cuántos niveles tiene el país y cómo
debe llamarse cada uno.

Chile:

Región
Provincia
Comuna

Perú:

Departamento
Provincia
Distrito

etc.
*/

export function cargarConfigPaisUbicacionAction(
    informacion
) {

    return async (
        dispatch,
        getState
    ) => {

        const {

            config,
            payload

        } = informacion;


        const pais =
            payload?.pais;


        if (
            !pais
        ) {

            return;

        }


        const codigoPais =
            String(
                pais
            )
                .trim()
                .toUpperCase();


        const estadoUbicacion =
            getState()
                .ubicacion;


        const yaCargada =
            estadoUbicacion
                .configPorPais[
                    codigoPais
                ];


        const cargando =
            estadoUbicacion
                .loadingConfigPorPais[
                    codigoPais
                ];


        /*
        Evitamos consultas duplicadas.
        */

        if (
            yaCargada ||
            cargando
        ) {

            return;

        }


        dispatch(
            cargarConfigPaisSolicito(
                codigoPais
            )
        );


        try {

            /*
            Normalizamos el código del país
            antes de enviarlo al backend.
            */

            const payloadNormalizado = {

                ...payload,

                pais:
                    codigoPais

            };


            const respuesta =
                await clienteAxios.post(
                    '/ubicacion/config',
                    payloadNormalizado,
                    config
                );


            dispatch(
                cargarConfigPaisExito({

                    pais:
                        codigoPais,

                    informacion:
                        respuesta
                            .data
                            .informacion

                })
            );


        } catch (
            error
        ) {

            const mensaje =
                error.response?.data ||
                {
                    msg:
                        'No se pudo cargar la configuración del país'
                };


            dispatch(
                cargarConfigPaisError({

                    pais:
                        codigoPais,

                    error:
                        mensaje

                })
            );

        }

    };

}


const cargarConfigPaisSolicito =
    (
        pais
    ) => ({

        type:
            CARGAR_CONFIG_PAIS_UBICACION_SOLICITO,

        payload:
            pais

    });


const cargarConfigPaisExito =
    (
        informacion
    ) => ({

        type:
            CARGAR_CONFIG_PAIS_UBICACION_EXITO,

        payload:
            informacion

    });


const cargarConfigPaisError =
    (
        error
    ) => ({

        type:
            CARGAR_CONFIG_PAIS_UBICACION_ERROR,

        payload:
            error

    });


/*
====================================
OPCIONES GENÉRICAS
====================================

Este reemplaza conceptualmente a:

cargarProvincias
cargarDepartamentos
cargarLocalidades

pero funciona para cualquier país.


Ejemplo:

POST /ubicacion/opciones

Body Argentina:

{
    pais: 'AR',
    nivel: 1
}


Body Chile:

{
    pais: 'CL',
    nivel: 2,
    parent: '13'
}


Body México:

{
    pais: 'MX',
    nivel: 3,
    parent: '14039'
}
*/

export function cargarOpcionesUbicacionAction(
    informacion
) {

    return async (
        dispatch,
        getState
    ) => {

        const {

            config,
            payload

        } = informacion;


        const pais =
            payload?.pais;


        const nivel =
            payload?.nivel;


        const parent =
            payload?.parent ??
            null;


        if (
            !pais ||
            !nivel
        ) {

            return;

        }


        const codigoPais =
            String(
                pais
            )
                .trim()
                .toUpperCase();


        const numeroNivel =
            Number(
                nivel
            );


        if (
            !Number.isInteger(
                numeroNivel
            ) ||
            numeroNivel <= 0
        ) {

            return;

        }


        const parentNormalizado =
            parent !== undefined &&
            parent !== null &&
            parent !== ''
                ?
                String(
                    parent
                )
                :
                null;


        const clave =
            crearClaveOpcionesUbicacion(
                codigoPais,
                numeroNivel,
                parentNormalizado
            );


        const estadoUbicacion =
            getState()
                .ubicacion;


        const yaCargadas =
            estadoUbicacion
                .opciones[
                    clave
                ];


        const cargando =
            estadoUbicacion
                .loadingOpciones[
                    clave
                ];


        /*
        Incluso un array vacío se considera
        una respuesta cargada.

        Por eso comprobamos undefined y no
        utilizamos simplemente:

        if (yaCargadas)
        */

        if (
            yaCargadas !==
                undefined ||
            cargando
        ) {

            return;

        }


        dispatch(
            cargarOpcionesSolicito(
                clave
            )
        );


        try {

            /*
            Armamos el payload definitivo
            que recibe el backend.
            */

            const payloadNormalizado = {

                pais:
                    codigoPais,

                nivel:
                    numeroNivel,

                ...(
                    parentNormalizado
                        ?
                        {
                            parent:
                                parentNormalizado
                        }
                        :
                        {}
                )

            };


            const respuesta =
                await clienteAxios.post(
                    '/ubicacion/opciones',
                    payloadNormalizado,
                    config
                );


            dispatch(
                cargarOpcionesExito({

                    clave,

                    pais:
                        codigoPais,

                    nivel:
                        numeroNivel,

                    parent:
                        parentNormalizado,

                    informacion:
                        respuesta
                            .data
                            .informacion

                })
            );


        } catch (
            error
        ) {

            const mensaje =
                error.response?.data ||
                {
                    msg:
                        'No se pudieron cargar las opciones de ubicación'
                };


            dispatch(
                cargarOpcionesError({

                    clave,

                    error:
                        mensaje

                })
            );

        }

    };

}


const cargarOpcionesSolicito =
    (
        clave
    ) => ({

        type:
            CARGAR_OPCIONES_UBICACION_SOLICITO,

        payload:
            clave

    });


const cargarOpcionesExito =
    (
        informacion
    ) => ({

        type:
            CARGAR_OPCIONES_UBICACION_EXITO,

        payload:
            informacion

    });


const cargarOpcionesError =
    (
        error
    ) => ({

        type:
            CARGAR_OPCIONES_UBICACION_ERROR,

        payload:
            error

    });


/*
====================================
LEGACY ARGENTINA
====================================

A partir de acá dejamos las acciones
anteriores funcionando.

No las usa el nuevo SelectorUbicacion,
pero no las eliminamos todavía porque
puede haber otros componentes del
frontend que dependan de ellas.
*/


/*
====================================
PROVINCIAS
====================================
*/

export function cargarProvinciasUbicacionAction(
    informacion
) {

    return async (
        dispatch,
        getState
    ) => {

        const provincias =
            getState()
                .ubicacion
                .provincias;


        const loading =
            getState()
                .ubicacion
                .loadingProvincias;


        if (
            provincias.length > 0 ||
            loading
        ) {

            return;

        }


        dispatch(
            cargarProvinciasSolicito()
        );


        try {

            const {
                config
            } = informacion;


            const respuesta =
                await clienteAxios.get(
                    '/ubicacion/provincias',
                    config
                );


            dispatch(
                cargarProvinciasExito(
                    respuesta
                        .data
                        .informacion
                )
            );


        } catch (
            error
        ) {

            const mensaje =
                error.response?.data ||
                {
                    msg:
                        'No se pudieron cargar las provincias'
                };


            dispatch(
                cargarProvinciasError(
                    mensaje
                )
            );

        }

    };

}


const cargarProvinciasSolicito =
    () => ({

        type:
            CARGAR_PROVINCIAS_UBICACION_SOLICITO

    });


const cargarProvinciasExito =
    (
        informacion
    ) => ({

        type:
            CARGAR_PROVINCIAS_UBICACION_EXITO,

        payload:
            informacion

    });


const cargarProvinciasError =
    (
        error
    ) => ({

        type:
            CARGAR_PROVINCIAS_UBICACION_ERROR,

        payload:
            error

    });


/*
====================================
DEPARTAMENTOS
====================================
*/

export function cargarDepartamentosUbicacionAction(
    informacion
) {

    return async (
        dispatch,
        getState
    ) => {

        const {

            config,
            provincia_id

        } = informacion;


        if (
            !provincia_id
        ) {

            return;

        }


        const estadoUbicacion =
            getState()
                .ubicacion;


        const yaCargados =
            estadoUbicacion
                .departamentos[
                    provincia_id
                ];


        const cargando =
            estadoUbicacion
                .loadingDepartamentos[
                    provincia_id
                ];


        if (
            yaCargados ||
            cargando
        ) {

            return;

        }


        dispatch(
            cargarDepartamentosSolicito(
                provincia_id
            )
        );


        try {

            const respuesta =
                await clienteAxios.get(
                    '/ubicacion/departamentos',
                    {

                        ...config,

                        params: {

                            ...(config?.params || {}),

                            provincia_id

                        }

                    }
                );


            dispatch(
                cargarDepartamentosExito({

                    provincia_id,

                    informacion:
                        respuesta
                            .data
                            .informacion

                })
            );


        } catch (
            error
        ) {

            const mensaje =
                error.response?.data ||
                {
                    msg:
                        'No se pudieron cargar los departamentos'
                };


            dispatch(
                cargarDepartamentosError({

                    provincia_id,

                    error:
                        mensaje

                })
            );

        }

    };

}


const cargarDepartamentosSolicito =
    (
        provincia_id
    ) => ({

        type:
            CARGAR_DEPARTAMENTOS_UBICACION_SOLICITO,

        payload:
            provincia_id

    });


const cargarDepartamentosExito =
    (
        informacion
    ) => ({

        type:
            CARGAR_DEPARTAMENTOS_UBICACION_EXITO,

        payload:
            informacion

    });


const cargarDepartamentosError =
    (
        error
    ) => ({

        type:
            CARGAR_DEPARTAMENTOS_UBICACION_ERROR,

        payload:
            error

    });


/*
====================================
LOCALIDADES
====================================
*/

export function cargarLocalidadesUbicacionAction(
    informacion
) {

    return async (
        dispatch,
        getState
    ) => {

        const {

            config,
            departamento_id

        } = informacion;


        if (
            !departamento_id
        ) {

            return;

        }


        const estadoUbicacion =
            getState()
                .ubicacion;


        const yaCargadas =
            estadoUbicacion
                .localidades[
                    departamento_id
                ];


        const cargando =
            estadoUbicacion
                .loadingLocalidades[
                    departamento_id
                ];


        if (
            yaCargadas ||
            cargando
        ) {

            return;

        }


        dispatch(
            cargarLocalidadesSolicito(
                departamento_id
            )
        );


        try {

            const respuesta =
                await clienteAxios.get(
                    '/ubicacion/localidades',
                    {

                        ...config,

                        params: {

                            ...(config?.params || {}),

                            departamento_id

                        }

                    }
                );


            dispatch(
                cargarLocalidadesExito({

                    departamento_id,

                    informacion:
                        respuesta
                            .data
                            .informacion

                })
            );


        } catch (
            error
        ) {

            const mensaje =
                error.response?.data ||
                {
                    msg:
                        'No se pudieron cargar las localidades'
                };


            dispatch(
                cargarLocalidadesError({

                    departamento_id,

                    error:
                        mensaje

                })
            );

        }

    };

}


const cargarLocalidadesSolicito =
    (
        departamento_id
    ) => ({

        type:
            CARGAR_LOCALIDADES_UBICACION_SOLICITO,

        payload:
            departamento_id

    });


const cargarLocalidadesExito =
    (
        informacion
    ) => ({

        type:
            CARGAR_LOCALIDADES_UBICACION_EXITO,

        payload:
            informacion

    });


const cargarLocalidadesError =
    (
        error
    ) => ({

        type:
            CARGAR_LOCALIDADES_UBICACION_ERROR,

        payload:
            error

    });